<template>
  <v-menu
    offset-y
    left
    nudge-bottom="14"
    min-width="230"
    content-class="user-profile-menu-content"
  >
    <template v-slot:activator="{ on, attrs }">
      <!-- <v-badge
        bottom
        color="success"
        overlap
        offset-x="12"
        offset-y="12"
        class="ms-4"
        dot
      > -->
      <v-avatar
        size="40px"
        v-bind="attrs"
        color="primary"
        class="v-avatar-light-bg primary--text ms-4"
        v-on="on"
      >
        <v-img
          v-if="getPhoto"
          :src="'data:image/jpeg;base64,' + getPhoto"
        ></v-img>
        <v-img
          v-else
          :src="require('@/assets/images/avatars/1.png')"
        ></v-img>
      </v-avatar>
      <!-- </v-badge> -->
    </template>
    <v-list>
      <div
        class="pb-3 pt-2"
        style="cursor: pointer"
        @click="profile"
      >
        <v-badge
          bottom
          color="success"
          overlap
          offset-x="12"
          offset-y="12"
          class="ms-4"
          dot
        >
          <v-avatar
            size="40px"
            color="primary"
            class="v-avatar-light-bg primary--text"
          >
            <v-img
              v-if="getPhoto"
              :src="'data:image/jpeg;base64,' + getPhoto"
            ></v-img>
            <v-img
              v-else
              :src="require('@/assets/images/avatars/1.png')"
            ></v-img>
          </v-avatar>
        </v-badge>
        <div
          class="d-inline-flex flex-column justify-center ms-3"
          style="vertical-align: middle"
        >
          <span class="tertiary--text subtitle-1 font-weight-semibold mb-n1">
            {{ getUser.name }}
          </span>
          <small class="text--disabled text-capitalize">{{ getUser.role.name }}</small>
        </div>
      </div>

      <v-divider></v-divider>

      <!-- Profile -->
      <v-list-item @click="profile">
        <v-list-item-icon class="me-2">
          <v-icon
            size="22"
            class="tertiary--text"
          >
            {{ icons.mdiAccountOutline }}
          </v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title class="tertiary--text"> Perfil </v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <!-- Email -->
      <v-list-item @click="messages">
        <v-list-item-icon class="me-2">
          <v-icon
            size="22"
            class="tertiary--text"
          >
            {{ icons.mdiEmailOutline }}
          </v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title class="tertiary--text"> Notificações </v-list-item-title>
        </v-list-item-content>
        <v-list-item-action>
          <v-badge
            v-if="getNotifications.length > 0"
            inline
            color="error"
            :content="getNotifications.length"
          >
          </v-badge>
        </v-list-item-action>
      </v-list-item>

      <!-- Chat -->
      <!-- <v-list-item href="#">
        <v-list-item-icon class="me-2">
          <v-icon size="22">
            {{ icons.mdiChatOutline }}
          </v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>Chat</v-list-item-title>
        </v-list-item-content>

        <v-list-item-action>
          <v-badge
            inline
            color="error"
            content="2"
          >
          </v-badge>
        </v-list-item-action>
      </v-list-item> -->

      <v-divider class="my-2"></v-divider>

      <!-- Settings -->
      <v-list-item @click="configurations">
        <v-list-item-icon class="me-2">
          <v-icon
            size="22"
            class="tertiary--text"
          >
            {{ icons.mdiCogOutline }}
          </v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title class="tertiary--text"> Configurações </v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <!-- Assinatura -->
      <v-list-item @click="assinatura">
        <v-list-item-icon class="me-2">
          <v-icon
            size="22"
            class="tertiary--text"
          >
            {{ icons.mdiCardBulletedOutline }}
          </v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title class="tertiary--text"> Assinatura </v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <!-- Pricing -->
      <v-list-item
        @click="pricing"
        v-if="getUser.is_tenant_owner"
      >
        <v-list-item-icon class="me-2">
          <v-icon
            size="22"
            class="tertiary--text"
          >
            {{ icons.mdiCurrencyUsd }}
          </v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title class="tertiary--text"> Preço e Planos </v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <!-- FAQ -->
      <v-list-item @click="faq">
        <v-list-item-icon class="me-2">
          <v-icon
            size="22"
            class="tertiary--text"
          >
            {{ icons.mdiHelpCircleOutline }}
          </v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title class="tertiary--text"> Ajuda e Suporte </v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-divider class="my-2"></v-divider>

      <!-- Logout -->
      <v-list-item @click="sendLogout()">
        <v-list-item-icon class="me-2">
          <v-icon
            size="22"
            class="error--text"
          >
            {{ icons.mdiLogoutVariant }}
          </v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title class="error--text"> Sair </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import {
  mdiAccountOutline,
  mdiEmailOutline,
  mdiCheckboxMarkedOutline,
  mdiChatOutline,
  mdiCogOutline,
  mdiCurrencyUsd,
  mdiHelpCircleOutline,
  mdiLogoutVariant,
  mdiCardBulletedOutline,
} from '@mdi/js'
import { mapActions, mapGetters } from 'vuex'

export default {
  data() {
    return {
      icons: {
        mdiAccountOutline,
        mdiEmailOutline,
        mdiCheckboxMarkedOutline,
        mdiChatOutline,
        mdiCogOutline,
        mdiCurrencyUsd,
        mdiHelpCircleOutline,
        mdiLogoutVariant,
        mdiCardBulletedOutline,
      },
    }
  },
  computed: {
    ...mapGetters('Login', ['getUser', 'getPhoto', 'getUser']),
    ...mapGetters('Notification', ['getNotifications']),
  },
  methods: {
    ...mapActions('Login', ['logout']),
    messages() {
      this.$router.push('/message')
    },
    pricing() {
      this.$router.push('/pricing')
    },
    faq() {
      this.$router.push('/faq')
    },
    configurations() {
      this.$router.push('/system/configuration')
    },
    assinatura() {
      this.$router.push('/assinatura')
    },
    sendLogout() {
      this.logout()
        .then(() => {
          localStorage.removeItem('access_token')
          localStorage.removeItem('conected')
          this.$router.push('/login')
        })
        .finally()
    },
    profile() {
      this.$router.push('/profile')
    },
  },
}
</script>

<style lang="scss">
.user-profile-menu-content {
  .v-list-item {
    min-height: 2.5rem !important;
  }
}
</style>
